<template>
  <div class="w-full">
    <router-link to="/user/activity" class="inline-block underline p-3">Lihat aktivitas member (login dan terakhir terlihat)</router-link>
    <div class="grid grid-cols-12 gap-4 my-3">
      <div class="col-span-12 sm:col-span-4">
        <div 
          class="flex flex-row shadow-md rounded p-4 duration-300 bg-white hover:bg-green-400"
          @mouseenter="cardHover = 'user'"
          @mouseleave="cardHover = ''"
        >
          <div
            class="flex items-center justify-center flex-shrink-0 h-12 w-12 rounded-xl duration-300"
            :class="cardHover == 'user' ? 'bg-green-100 text-green-500' : 'bg-green-100 text-green-500'"
          >
            <i class="fas fa-user fa-2x"></i>
          </div>
          <div class="flex flex-col flex-grow ml-4">
            <div class="font-medium text-sm duration-300" :class="cardHover == 'user' ? 'text-white' : 'text-gray-500'">Total User</div>
            <div class="font-bold text-lg duration-300" :class="cardHover == 'user' ? 'text-white' : 'text-gray-700'">{{ usersPaginatedData.total }}</div>
          </div>
        </div>
      </div>
      <div class="col-span-12 sm:col-span-4">
        <router-link
          to="/user/mentor"
          class="flex justify-between shadow-md rounded p-4 items-center duration-300 hover:text-white bg-white hover:bg-indigo-400"
          @mouseenter="cardHover = 'mentor'"
          @mouseleave="cardHover = ''"
        >
          <div class="flex flex-row">
            <div
              class="flex items-center justify-center flex-shrink-0 h-12 w-12 rounded-xl bg-indigo-100 text-indigo-500"
            >
              <i class="fas fa-user-graduate fa-2x"></i>
            </div>
            <div class="flex flex-col flex-grow ml-4">
              <div class="font-medium text-sm duration-300" :class="cardHover == 'mentor' ? 'text-white' : 'text-gray-500'">Total Mentor</div>
              <div class="font-bold text-lg duration-300" :class="cardHover == 'mentor' ? 'text-white' : 'text-gray-700'">{{ mentorList.length }}</div>
            </div>
          </div>
          <i class="fas fa-arrow-right ml-1"></i>
        </router-link>
      </div>
      <div class="col-span-12 sm:col-span-4">
        <router-link
          to="/user/admin"
          class="flex justify-between shadow-md rounded p-4 items-center duration-300 hover:text-white bg-white hover:bg-red-500"
          @mouseenter="cardHover = 'admin'"
          @mouseleave="cardHover = ''"
        >
          <div class="flex flex-row ">
            <div
              class="flex items-center justify-center flex-shrink-0 h-12 w-12 rounded-xl bg-red-100 text-red-500"
            >
              <i class="fas fa-user-secret fa-2x"></i>
            </div>
            <div class="flex flex-col flex-grow ml-4">
              <div class="font-medium text-sm duration-300" :class="cardHover == 'admin' ? 'text-white' : 'text-gray-500'">Total Admin</div>
              <div class="font-bold text-lg duration-300" :class="cardHover == 'admin' ? 'text-white' : 'text-gray-700'">{{ adminPagination.total }}</div>
            </div>
          </div>
          <i class="fas fa-arrow-right ml-1"></i>
        </router-link>
      </div>
    </div>
    <div v-if="false" class="bg-white shadow-md rounded p-4 w-full">
      <div class="flex justify-between pb-4">
        <div>
          <i class="fas fa-chart-bar mr-2" /> 
          <span class="text-medium text-lg">Statistik User</span>
        </div>
        <div>
          <litepie-datepicker
            use-range
            separator=" - "
            v-model="reportDate"
            v-slot="{ value, placeholder, clear }"
            :formatter="dateFormatter"
            placeholder="7 hari terakhir"
          >
            <span class="p-input-icon-right">
              <i
                :class="['pi', { 'pi-calendar': !value, 'pi-times': value }]"
                @click="clear"
              />
              <InputText
                :value="value || placeholder"
                :placeholder="placeholder"
                class="font-sans text-sm rounded-md py-2"
              />
            </span>
          </litepie-datepicker>
        </div>
      </div>
      <UserReportChart :chartData="chartData" :width="350" :height="80" />
    </div>
    <DataTable
      ref="userTable"
      :value="userList"
      :paginator="true"
      :rows="query.perPage"
      dataKey="id"
      :rowHover="true"
      filterDisplay="menu"
      :loading="isLoading"
      @page="getResult($event)"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[10, 25, 50, 100, 200, 500]"
      :first="usersPaginatedData.from"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      responsiveLayout="scroll"
      :totalRecords="usersPaginatedData.total"
      :lazy="true"
      showGridlines
      class="p-datatable-sm font-sans text-sm mt-5"
      @rowExpand="onRowExpand" 
      @rowCollapse="onRowCollapse"
      v-model:expandedRows="selectedUser"
    >
      <template #empty>
        <div class="text-center">
          <span class="font-bold text-base">No Data Found.</span>
        </div>
      </template>
      <template #header>
        <div class="flex items-center justify-between">
          <h5 class="p-m-0 text-lg">List User</h5>
          <div class="flex justify-center items-center space-x-2">
            <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <InputText
                v-model="query.search"
                @keyup.enter="searchUsers"
                placeholder="Cari User"
                class="font-sans"
                />
            </span>
            <Button 
                dense
                label="Tambah User"
                class="p-button-primary font-semibold"
                icon="pi pi-plus"
                @click.prevent="$router.push('/user/add')"
            />
          </div>
        </div>
      </template>
      <Column field="id" header="ID"></Column>
      <Column field="uuid" header="UUID"></Column>
      <Column field="name" header="Nama"></Column>
      <Column field="email" header="Email"></Column>
      <Column field="phone" header="Phone"></Column>
      <Column :expander="true" headerStyle="width: 3rem" header="Kelas" />
      <Column field="id" header="Aksi" bodyClass="md:w-[16.5rem] space-x-2">
        <template #body="{data}">
          <router-link
            :to="'/user/' + data.uuid + '/detail'"
            class="w-full inline-flex items-center justify-center rounded-md border border-transparent shadow-sm hover:shadow-lg p-2 bg-blue-500 text-sm font-medium text-white hover:bg-blue-600  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-700 sm:w-auto sm:text-sm"
            v-tooltip.top="'Detail User'"
          >
            <i class="fas fa-eye w-4 h-4"></i>
          </router-link>
          <!-- <router-link
            :to="'/user/' + data.id + '/edit'"
            class="w-full inline-flex items-center justify-center rounded-md border border-transparent shadow-sm hover:shadow-lg px-4 py-2 bg-yellow-500 text-sm font-medium text-white hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-700 sm:ml-3 sm:w-auto sm:text-sm"
          >
            <i class="fas fa-user-edit w-4 h-4 mr-2"></i>
            Edit
          </router-link> -->
          <span
            v-if="data.role_id == 2"
            class="w-full inline-flex items-center justify-center rounded-md border border-transparent shadow-sm hover:shadow-lg p-2 bg-red-500 text-sm font-medium text-white hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-700 sm:w-auto sm:text-sm"
          >
            <i class="fas fa-user-graduate mr-2"></i>
            Sudah Menjadi Mentor
          </span>
          <button
            v-else
            @click.prevent="addToMentor(data)"
            class="w-full inline-flex items-center justify-center rounded-md border border-transparent shadow-sm hover:shadow-lg p-2 bg-green-500 text-sm font-medium text-white hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-700 sm:w-auto sm:text-sm"
          >
            <i class="fas fa-user-plus w-4 h-4 mr-2"></i>
            Tambah Sebagai Mentor
          </button>
        </template>
      </Column>
      <template #expansion="slotProps">
        <div v-if="loadingUserClassroom">
          <p class="text-center py-3 font-bold">Sedang memuat data kelas user...</p>
        </div>
        <div v-else>
          <div v-if="slotProps.data.user_classrooms?.length > 0">
            <DataTable 
              :value="slotProps.data.user_classrooms" 
              responsiveLayout="scroll"
              :paginator="true"
              :rows="5"
              dataKey="id"
              :rowHover="true"
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              :rowsPerPageOptions="[5, 10, 25, 50]"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
              class="p-datatable-sm font-sans text-sm"
              showGridlines
              v-model:filters="filtersClassroom"
              filterDisplay="menu"
              :globalFilterFields="['classroom.code','classroom.name','level.name','joined_at']"
            >
              <template #header>
                <div class="flex items-center justify-between">
                  <div>
                    <p class="text-lg">{{ slotProps.data.name }}</p>
                    <p class="text-sm font-normal">{{ slotProps.data.email }}</p>
                  </div>
                  <div class="flex">
                    <span class="p-input-icon-left">
                      <i class="pi pi-search" />
                      <InputText
                        v-model="filtersClassroom['global'].value"
                        placeholder="Cari"
                      />
                    </span>
                    <div class="bg-purple-500 rounded-md px-3 py-2 text-white text-xs self-center ml-2">
                      Jumlah Kelas
                      <span class="p-1 bg-purple-600 rounded-sm text-xs font-bold ml-1">
                        {{ slotProps.data.user_classrooms?.length }}
                      </span>
                    </div>
                  </div>
                </div>
              </template>
              <Column field="classroom.code" header="Kode Kelas" sortable>
                <template #body="{data}">
                  {{ data.classroom?.code ? data.classroom?.code : data.level?.code }}
                </template>
              </Column>
              <Column field="classroom.name" header="Kelas" sortable></Column>
                <template #body="{data}">
                  {{ data.classroom?.name ? data.classroom?.name : data.level?.name }}
                </template>
              <Column field="level.name" header="Level Terakhir" sortable></Column>
              <Column field="joined_at" header="Tanggal Bergabung" sortable>
                <template #body="{data}">
                  {{ formatDate(data.joined_at) }}
                </template>
              </Column>
              <Column header="Regenerate Sertif">
                <template #body="{data}">
                  <button
                    class="m-1 focus:outline-none text-white text-sm p-2 rounded-md bg-red-500 hover:bg-red-600 hover:shadow-sm items-center inline-block font-medium"
                    @click="generateCompletion(data)"
                    v-tooltip.top="'Buat ulang sertifikat completion'"
                  >
                  <i class="fas fa-check-double"></i>
                    Completion
                  </button>
                  <button
                    class="m-1 focus:outline-none text-white text-sm p-2 rounded-md bg-indigo-500 hover:bg-indigo-600 hover:shadow-sm items-ceter inline-block font-medium"
                    @click="generateGraduation(data)"
                    v-tooltip.top="'Buat ulang sertifikat graduation'"
                  >
                  <i class="fas fa-graduation-cap"></i>
                    Graduation
                  </button>
                </template>
              </Column>
              <Column field="is_done" header="Status" sortable>
                <template #body="{data}">
                  <span
                      v-if="data?.is_done == 1"
                      class="relative inline-block px-3 py-1 font-semibold text-green-700 leading-tight mt-1">
                      <span aria-hidden
                          class="absolute inset-0 bg-green-400 opacity-50 rounded"></span>
                      <span class="relative">Lulus</span>
                  </span>
                  <span
                      v-else
                      class="relative inline-block px-3 py-1 font-semibold text-red-700 leading-tight mt-1">
                      <span aria-hidden
                          class="absolute inset-0 bg-red-400 opacity-50 rounded"></span>
                      <span class="relative">Belum Lulus</span>
                  </span>
                  <br>
                    <span
                    v-if="data?.is_locked"
                      class="relative inline-block px-3 py-1 font-semibold text-red-700 leading-tight mt-1">
                      <span aria-hidden
                          class="absolute inset-0 bg-red-400 opacity-50 rounded"></span>
                      <span class="relative">Terkunci</span>
                  </span>
                </template>
              </Column>
            </DataTable>
          </div>
          <div v-else>
            <p class="text-center py-3 font-semibold text-red-500">Belum memiliki kelas</p>
          </div>
        </div>
      </template>
    </DataTable>

    <transition name="fade">
      <div
        v-if="displayModal"
        v-on:click="closeModal()"
        class="opacity-30 fixed inset-0 z-40 bg-black"
      ></div>
    </transition>
    <transition
      enter-active-class="animated bounceIn"
      leave-active-class="animated bounceOut"
    >
      <div
        v-if="displayModal"
        class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex"
      >
        <div class="relative w-3/4 md:w-1/4 my-6 mx-auto">
          <div
            v-click-away="closeModal"
            class="border-0 rounded-lg shadow-2xl relative flex flex-col w-full bg-white outline-none focus:outline-none"
          >
            <div
              class="flex items-start justify-between items-center p-3 border-b border-solid border-gray-300 rounded-t bg-indigo-700"
            >
              <h3 class="text-xl font-semibold text-white">
                Tambah Sebagai Mentor
              </h3>
              <button
                class="p-1 ml-auto bg-transparent border-0 text-black float-right text-xl leading-none font-semibold outline-none focus:outline-none"
                v-on:click="closeModal()"
              >
                <i
                  class="fas fa-times h-5 w-5 text-white outline-none focus:outline-none"
                ></i>
              </button>
            </div>
            <div class="relative px-6 pt-3 pb-6">
              <div class="w-full pb-3">
                <label for="uuid" class="block text-sm font-medium text-gray-700">
                  Nama User
                </label>
                <div class="mt-1">
                  <input
                    disabled
                    type="text"
                    class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md text-gray-500 bg-gray-50"
                    id="uuid"
                    v-model="payload.name"
                  />
                </div>
              </div>
              <div class="w-full pb-3">
                <label
                  for="shortDescription"
                  class="block text-sm font-medium text-gray-700"
                >
                  Deskripsi mentor
                </label>
                <div class="mt-1">
                  <textarea
                    id="shortDescription"
                    name="shortDescription"
                    rows="3"
                    v-model="payload.short_description"
                    class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border-gray-300 rounded-md"
                    placeholder="Masukkan Deksripsi Mentor"
                  ></textarea>
                </div>
              </div>
              <div class="text-right">
                <button
                  @click="submit"
                  class="inline-flex justify-center text-white bg-red-500 border border-solid border-red-500 hover:bg-transparent hover:text-red-500 active:bg-red-600 font-bold uppercase text-sm px-3 py-2 rounded outline-none focus:outline-none"
                  type="button"
                  style="transition: all .15s ease"
                >
                  Tambah
                </button>
              </div>
            </div>
            <!--footer-->
            <!-- <div class="flex items-center justify-end p-3 border-t border-solid border-gray-300 rounded-b">
              <button class="text-red-500 bg-transparent border border-solid border-red-500 hover:bg-red-500 hover:text-white active:bg-red-600 font-bold uppercase text-sm px-6 py-3 rounded outline-none focus:outline-none mr-1 mb-1" type="button" style="transition: all .15s ease" v-on:click="closeModal()">
                Tambah
              </button>
            </div> -->
          </div>
        </div>
      </div>
    </transition>

    <!-- modal regenerate -->
    <transition name="fade">
      <div 
        v-if="displayRegenerate"
        class="opacity-30 fixed inset-0 z-40 bg-black"
      ></div>
    </transition>
    <transition 
      enter-active-class="animated bounceIn"
      leave-active-class="animated bounceOut"
    >
    <div v-if="displayRegenerate"
      class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
      <div class="relative w-3/4 md:w-1/4 m-auto">
        <div v-click-away="closeRegenerate" class="border-0 rounded-2xl shadow-2xl relative flex flex-col w-full bg-white outline-none focus:outline-none">
          <div
            class="relative p-3 border-b border-solid border-gray-300 rounded-t-2xl"
            :class="payloadRegenerate?.type == 'graduation' ? 'bg-indigo-500' : 'bg-red-500'"
          >
            <div class="text-white text-8xl text-center">
              <i 
                class="fas"
                :class="payloadRegenerate?.type == 'graduation' ? 'fa-graduation-cap' : 'fa-check-double'"
              ></i>
            </div>
            <div class="pt-3 text-white text-center font-semibold text-xl">
              REGENERATE CERTIFICATE
            </div>
            <div class="text-white py-2 text-center font-normal text-sm">
              Apakah yakin ingin regenerate sertifikat <span class="font-bold">{{ payloadRegenerate.type }}</span>, member <span class="font-bold">{{ payloadRegenerate?.detail?.name }} ({{payloadRegenerate?.detail?.email}})</span> di kelas <span class="font-bold">{{ payloadRegenerate.detail?.classroom?.name}}</span> ?
            </div>
            <button
              class="absolute top-2 right-2.5 text-2xl leading-none font-semibold outline-none focus:outline-none"
              v-on:click="closeRegenerate">
              <i class="fas fa-times h-5 w-5 text-white outline-none focus:outline-none"></i>
            </button>
          </div>
          <div class="relative p-4">
            <div class="w-full flex justify-evenly">
              <button @click="closeRegenerate" class="px-10 py-1 text-white bg-gray-400 hover:bg-gray-600 rounded-md font-semibold">No</button>
              <button @click="generateCertifiate" class="px-10 py-1 text-white rounded-md font-semibold" :class="payloadRegenerate.type == 'graduation' ? 'bg-indigo-500 hover:bg-indigo-700' : 'bg-red-500 hover:bg-red-700 disabled:opacity-50 disabled:cursor-wait'"
              :disabled="loadingGenerate"
              >
                <i v-if="loadingGenerate" class="fas fa-spinner animate-spin"></i>
                <span v-else>Yes</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    </transition>
    <Toast />
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from "vuex"
import UserReportChart from "./components/UserReportChart.vue"
import LitepieDatepicker from 'litepie-datepicker'
import { Classroom } from '@/api/classroom'
import { FilterMatchMode } from 'primevue/api'
import moment from 'moment'

export default {
  name: "User",
  components: {
    UserReportChart,
    LitepieDatepicker,
  },
  data() {
    return {
      modal: false,
      payload: {
        name: '',
        uuid: "",
        short_description: "",
      },
      displayModal: false,
      query: {
        page: 1,
        perPage: 10,
        search: "",
        from: 1,
        total: 0,
      },
      dateFormatter: {
        date: 'DD-MM-YYYY',
        month: 'MMM'
      },
      reportDate: {
        startDate: null,
        endDate: null,
      },
      selectedUser: [],
      filtersClassroom: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      loadingUserClassroom: false,
      displayRegenerate: false,
      payloadRegenerate: {
        detail: {},
        type: '',
      },
      loadingGenerate: false,
      cardHover: '',
    };
  },
  created() {
    if (this.userList.length == 0) {
      this.fetchAllUsers(this.query);
      this.query.page = this.usersPaginatedData.page
      this.query.total = this.usersPaginatedData.total;
    } else {
      this.query.page = this.usersPaginatedData.page;
      this.query.perPage = this.usersPaginatedData.perPage;
      this.query.from = this.usersPaginatedData.from;
      this.query.total = this.usersPaginatedData.total;
    }
    this.fetchUserReport();
    if (this.mentorList.length <= 0) {
      this.fetchAllMentors();
    }
    if(this.admins.length <= 0) {
      const query = {
        page: 1,
        perPage: 10,
      }
      this.fetchListAdmins(query)
    }
  },
  computed: {
    ...mapGetters([
      "userList",
      "usersPaginatedData",
      "isLoading",
      "isSuccess",
      "message",
      "userReport",
      "mentorList",
      "admins",
      "adminPagination",
      "isSuccessMentor",
      "isLoadingMentor",
      "messageMentor",
    ]),
    chartData() {
      const reportData = this.userReport;

      return {
        labels: reportData.map((data) => data.date),
        datasets: [
          {
            label: "User",
            backgroundColor: "#f87979",
            data: reportData.map((data) => data.total),
          },
        ],
      };
    },
  },
  methods: {
    ...mapActions(["fetchAllUsers", "assignMentor", "fetchUserReport", "fetchAllMentors", "fetchListAdmins", "updateUserList"]),
    getResult(event) {
      this.query.page = event.page + 1;
      this.query.perPage = event.rows;
      this.fetchAllUsers(this.query);
    },
    async searchUsers(event) {
      this.query.search = event.target.value;
      this.query.page = 1;
      await this.fetchAllUsers(this.query);
      this.query.perPage = this.usersPaginatedData.perPage;
      // clearTimeout(this.debounce);
      // this.debounce = setTimeout(async () => {
      // }, 1000);
    },
    openModal() {
      this.displayModal = true;
    },
    closeModal() {
      this.displayModal = false;
    },
    addToMentor(data) {
      this.payload.name = data.name
      this.payload.uuid = data.uuid
      this.displayModal = true;
    },
    async submit() {
      if (!this.payload.short_description) {
        this.$toast.add({
          severity: "error",
          summary: "Failed",
          detail: "Silahkan Isi Deskripsi Mentor",
          life: 3000,
        });
      } else {
        await this.assignMentor(this.payload);
        if (this.isSuccessMentor) {
          this.$toast.add({
            severity: "success",
            summary: "Success",
            detail: this.messageMentor,
            life: 3000,
          });
          this.fetchAllMentors();
          this.userList.filter(el => {
            if (el.uuid == this.payload.uuid) {
              el.role_id = 2
            }
          })
          // this.fetchAllUsers(this.query);
          this.payload.uuid = ''
          this.displayModal = false
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Failed",
            detail: this.messageMentor,
          });
        }
      }
    },
    async onRowExpand(event) {
      this.loadingUserClassroom = true
      await Classroom.getUserClassroom(event.data.uuid)
      .then(async res => {
        let selectedUser = this.userList.filter(el => el.uuid == event.data.uuid)
        let cloneUserList = []
        this.userList.forEach(user => {
          if(selectedUser[0].uuid == user.uuid) {
            cloneUserList.push({
              ...user,
              user_classrooms: res.data.data
            })
          } else{
            cloneUserList.push({
              ...user,
            })
          }
        })
        await this.updateUserList(cloneUserList)
        this.loadingUserClassroom = false
      })
      .catch(error => {
        this.loadingUserClassroom = false
        this.$toast.add({severity: 'error', summary: 'Error', detail: error, life: 3000});
      })
    },
    onRowCollapse(event) {
      // console.log(event)
      // this.$toast.add({severity: 'success', summary: 'Product Collapsed', detail: event.data.name, life: 3000});
    },
    formatDate(date) {
      return moment(date).locale('id').format('DD MMM YYYY HH:mm:ss')
    },
    generateGraduation(data) {
      this.payloadRegenerate.detail = {}
      this.payloadRegenerate.detail = data
      this.payloadRegenerate.type = 'graduation'
      this.displayRegenerate = true
    },
    generateCompletion(data) {
      this.payloadRegenerate.detail = {}
      this.payloadRegenerate.detail = data
      this.payloadRegenerate.type = 'completion'
      this.displayRegenerate = true 
    },
    closeRegenerate() {
      this.displayRegenerate = false
      this.loadingGenerate = false
    },
    async generateCertifiate() {
      this.loadingGenerate = true
      if (this.payloadRegenerate.type == 'graduation') {
        await Classroom.regenerateGraduation(this.payloadRegenerate.detail?.classroom?.code, this.payloadRegenerate.detail?.uuid)
        .then(async res => {
          if(res.data.success) {
            window.open(res.data.data.file, '_blank')
            this.closeRegenerate()
            this.$toast.add({severity:'success', summary:'Success', detail:'Berhasil generate sertifikat graduation', life: 3000});
          } else {
            this.closeRegenerate()
            this.$toast.add({severity:'error', summary:'Failed', detail:'Terjadi Kesalahan', life: 3000});
          }
        })
        .catch(err => {
          this.closeRegenerate()
          err.errors.forEach(el => {
            this.$toast.add({severity:'error', summary:'Failed', detail:el.message, life: 3000});
          })
        })
      } else {
        await Classroom.regenerateCompletion(this.payloadRegenerate.detail?.classroom?.code, this.payloadRegenerate.detail?.uuid)
        .then(async res => {
          if(res.data.success) {
            window.open(res.data.data.file, '_blank')
            this.closeRegenerate()
            this.$toast.add({severity:'success', summary:'Success', detail:'Berhasil generate sertifikat completion', life: 3000});
          } else {
            this.closeRegenerate()
            this.$toast.add({severity:'error', summary:'Failed', detail:'Terjadi Kesalahan', life: 3000});
          }
        })
        .catch(err => {
          this.closeRegenerate()
          err.errors.forEach(el => {
            this.$toast.add({severity:'error', summary:'Failed', detail:el.message, life: 3000});
          })
        })
      }
    }
  },
  watch: {
    reportDate(val) {
      this.fetchUserReport(val);
    }
  }
};
</script>
